module.exports = __webpack_public_path__ + "img/nav2.8ddaf728.png";